import React from 'react';
import { Link } from 'react-router-dom';

interface NavigationLinkProps {
  href: string;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const NavigationLink: React.FC<NavigationLinkProps> = ({ href, onClick, children, className, style = {} }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick();
  };

  const defaultStyle = {
    textDecoration: 'none',
    color: 'inherit',
    ...style
  };

  return (
    <Link to={href} className={className} style={defaultStyle} onClick={handleClick}>
      {children}
    </Link>
  );
};
